import React from 'react';
import PropTypes from 'prop-types';
import { Steps } from 'antd';
import './RDSteps.scss';

const { Step } = Steps;

const RDSteps = ({ steps, current, statusOfStep, direction, onChange, stepsStyle }) => (
  <Steps
    current={current}
    status={statusOfStep}
    direction={direction}
    onChange={onChange}
    style={stepsStyle}
  >
    {steps.map((item) => (
      <Step
        key={item.title}
        title={item.title}
        description={item?.description}
        subTitle={item?.subTitle}
        icon={item?.icon}
        status={item?.status}
        disabled={item?.disabled}
      />
    ))}
  </Steps>
);

RDSteps.defaultProps = {
  steps: [],
  current: 0,
  statusOfStep: 'success',
  direction: 'horizontal',
  onChange: () => {},
  stepsStyle: {},
};

RDSteps.propTypes = {
  /** Steps Options - title | description | subTitle | icon | status | disabled
   *
   * title - Title of the step
   *
   * description - Description of the step, optional
   *
   * subTitle - Subtitle of the step, optional
   *
   * icon - Icon of the step, optional
   *
   * status - To specify the status. It will be automatically set by current of Steps if not configured. Can be: wait | process | finish | error, optional
   *
   * disabled - Disable click, optional
   */
  steps: PropTypes.arrayOf(PropTypes.shape({})),
  /** To set the current step, counting from 0 */
  current: PropTypes.number,
  /** To specify the status of current step, can be: wait | process | finish | error */
  statusOfStep: PropTypes.string,
  /** To specify the direction of the step bar, horizontal or vertical */
  direction: PropTypes.string,
  /** Trigger when Step is changed */
  onChange: PropTypes.func,
  /** Inline style to apply to the steps container */
  stepsStyle: PropTypes.shape({}),
};

export default RDSteps;
